import { Point } from "popmotion/lib/types";
import InputState from "../../engine/inputActions/InputState";
import { openModal } from "../../ui/containers/Modal";
import { createElement } from "../../ui/ui";
import { Actor } from "../actors/Actor";
import { setFocusToCursor, setFocusToTarget } from "../commands/focusUtils";
import { gameData } from "../GameManager";
import { PromptTypes } from "../ui/prompts";
import { Ability } from "./Ability";
import { TargetOptions, TargetTypes } from "./Target";

export const runAbilityPrompts = async (ability: Ability, actor: Actor) => {
  if (ability.target) {
    let options = ability.target.validate(actor);
    if (!options.valid) return options;
    options = await promptForTarget(ability, actor, options);
    if (!options.valid) return options;
    options = await promptForAbility(ability, actor, options);
    if (!options.valid) return options;
    return options;
  } else {
    console.warn("Ability has no target");
  }
};

export const promptForAbility = (
  ability: Ability,
  actor: Actor,
  options: TargetOptions
) => {
  return new Promise<TargetOptions>((r) => {
    if (ability.target) {
      const prompt = PromptTypes[ability.target.prompt];
      if (prompt) {
        if (ability.target) {
          openModal(
            createElement(
              prompt,
              { x: 0, y: 0, w: 40, h: 14 },
              {
                ...ability.target.promptProps,
                actor: actor,
                onResult: (result: any) => {
                  Object.assign(options, result);
                  r(options);
                },
                onCancel: () => {
                  r({ valid: false });
                },
              }
            )
          );
        }
      } else {
        r(options);
      }
    }
  });
};

export const promptForTarget = (
  ability: Ability,
  actor: Actor,
  options: TargetOptions
) => {
  return new Promise<TargetOptions>((r) => {
    if (ability.target) {
      const type = ability.target.type;
      if (type === TargetTypes.PIECE || type === TargetTypes.TARGET) {
        gameData.target = ability.target;
        gameData.targetCallback = (pos?: Point) => {
          InputState.popKeyHandler();
          InputState.popInputHandler();
          if (pos) {
            if (ability.target) {
              r(ability.target?.validate(actor, pos));
            }
          } else {
            options.valid = false;
            r(options);
          }
          setFocusToCursor();
          gameData.target = null;
          gameData.targetCallback = null;
        };

        InputState.pushKeyHandler(["graphMovement", "advance", "cancel"]);
        InputState.pushInputHandler(["target", "move"]);

        setFocusToTarget();
        return; //target callback will resolve the promise
      }
    }
    r(options);
  });
};
